import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Phone({ color = 'icon.primary', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 24 25' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.1305 13.8807C8.96054 12.7107 8.07854 11.4007 7.49254 10.0717C7.36954 9.79069 7.44154
      9.46169 7.65854 9.24469L8.47754 8.42569C9.14854 7.75469 9.14854 6.80569 8.56254 6.21969L7.38954
      5.04669C6.60854 4.26569 5.34254 4.26569 4.56154 5.04669L3.90954 5.69769C3.16854 6.43869 2.85954
      7.50769 3.05954 8.56769C3.55354 11.1807 5.07154 14.0417 7.52054 16.4907C9.96954 18.9397 12.8305
      20.4577 15.4435 20.9517C16.5035 21.1517 17.5725 20.8427 18.3135 20.1017L18.9645 19.4507C19.7455
      18.6697 19.7455 17.4037 18.9645 16.6227L17.7915 15.4497C17.2055 14.8637 16.2555 14.8637 15.6705
      15.4497L14.7675 16.3537C14.5505 16.5707 14.2215 16.6437 13.9405 16.5197C12.6115 15.9327 11.3005
      15.0497 10.1305 13.8807Z'
        stroke={color}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M21 9.00781V3.00781H15'
        stroke={color}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
      <Path
        d='M15 9.00781L21 3.00781'
        stroke={color}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='transparent'
      />
    </IconBase>
  )
}

Phone.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Phone
